// Initialize FirstPromoter when the app loads
export const initFirstPromoter = () => {
  // Check if we're in a browser environment
  if (typeof window === 'undefined') return;

  // Debugging logs removed for production

  // Force a click event after a short delay to ensure everything is loaded
  setTimeout(() => {
    if (window.fpr && typeof window.fpr === 'function') {
      window.fpr('click');
      // Click event sent
    } else {
      // FirstPromoter not loaded
    }
  }, 1000);

  // Also try on page visibility change (for SPAs)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && window.fpr) {
      window.fpr('click');
    }
  });
};